import React from 'react';
import styled, { keyframes, ThemeProvider } from 'styled-components';
import { motion } from 'framer-motion';

const theme = {
    primaryColor: '#e91e63',
    secondaryColor: '#fce4ec',
    textColor: '#333',
    fontFamily: 'Dancing Script, cursive',
};

const floatingHearts = keyframes`
    0% { transform: translateY(0) rotate(-45deg) scale(0); opacity: 0; }
    50% { opacity: 1; transform: translateY(50vh) rotate(-45deg) scale(1); }
    100% { transform: translateY(100vh) rotate(-45deg) scale(0.8); opacity: 0; }
`;

const HeartRainContainer = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
    z-index: 2;
    overflow: hidden;
`;

const FallingHeart = styled.div`
    color: ${props => props.theme.primaryColor};
    font-size: 1.5em;
    position: absolute;
    transform: rotate(-45deg);
    transform-origin: top left;
    animation: ${floatingHearts} ${props => props.duration}s linear infinite;
    left: ${props => props.left}%;
    opacity: ${props => props.opacity};
`;

const MessageContainer = styled(motion.div)`
    position: relative;
    width: 90%;
    max-width: 400px;
    height: auto;
    min-height: 250px;
    background-color: rgba(255, 255, 255, 0.8);
    border-radius: 10%;
    clip-path: polygon(50% 0%, 100% 38%, 82% 100%, 18% 100%, 0% 38%);
    padding: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    margin-bottom: 50px;
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
    animation: none;
    backdrop-filter: blur(10px);
    z-index: 1;
    
    &::before {
        content: "";
        position: absolute;
        top: -5px;
        left: -5px;
        right: -5px;
        bottom: -5px;
        border-radius: 10%;
        background: linear-gradient(to bottom, #ffc0cb, #f48fb1);
        opacity: 0.7;
        z-index: -1;
    }

    @media (max-width: 768px) {
        width: 95%;
        padding: 15px;
        border-radius: 15%;
        clip-path: polygon(50% 0%, 100% 30%, 82% 100%, 18% 100%, 0% 30%);
    }

    @media (max-width: 480px) {
        width: 98%;
        padding: 10px;
        font-size: 0.9em;
    }
`;

const Greeting = styled.h2`
    font-size: 1.8em;
    margin-bottom: 8px;
    text-shadow: 1px 1px #f48fb1;
    color: ${(props) => props.theme.primaryColor};
    word-wrap: break-word; /* Add this */
    max-width: 90%; /* Add this */

    @media (max-width: 768px) {
        font-size: 1.6em;
    }

    @media (max-width: 480px) {
        font-size: 1.4em;
    }
`;

const Wish = styled.p`
    font-size: 1em;
    line-height: 1.4;
    font-weight: bold;
    color: ${(props) => props.theme.textColor};
    word-wrap: break-word; /* Add this */
    max-width: 90%; /* Add this */

    @media (max-width: 768px) {
        font-size: 0.9em;
        line-height: 1.3;
    }

    @media (max-width: 480px) {
        font-size: 0.85em;
        line-height: 1.2;
    }
`;

const generateRandom = (min, max) => Math.random() * (max - min) + min;

function BirthdayMessage({ recipient }) {
    const heartRainCount = 20;
    const hearts = Array.from({ length: heartRainCount }, (_, index) => ({
        id: index,
        left: generateRandom(0, 100),
        duration: generateRandom(5, 15),
        opacity: generateRandom(0.5, 1),
        delay: generateRandom(0, 5),
    }));

    return (
        <ThemeProvider theme={theme}>
            <MessageContainer
                initial={{ opacity: 0, scale: 0.8, rotate: 5 }}
                animate={{ opacity: 1, scale: 1, rotate: 0 }}
                transition={{ duration: 0.8, ease: 'easeInOut' }}
            >
                <HeartRainContainer>
                    {hearts.map(heart => (
                        <FallingHeart
                            key={heart.id}
                            style={{ animationDelay: `${heart.delay}s` }}
                            left={heart.left}
                            duration={heart.duration}
                            opacity={heart.opacity}
                        >
                            ❤️
                        </FallingHeart>
                    ))}
                </HeartRainContainer>
                <Greeting>Dearest {recipient}!</Greeting>
                <Wish>With every beat of my heart, I wish you the most magical birthday. Your presence
                    is the greatest gift. May your day be as beautiful & radiant as you are to me.I
                    love you more than words can say.</Wish>
            </MessageContainer>
        </ThemeProvider>
    );
}

export default BirthdayMessage;
